import { render, staticRenderFns } from "./LeftBarIdentify.vue?vue&type=template&id=11ba3b08"
import script from "./LeftBarIdentify.vue?vue&type=script&lang=js"
export * from "./LeftBarIdentify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports